/*
 * THE PILL BAND for a coworld's wiki and forum in creator-room chrome
 * (`isCommunityRoom`). Their `<main id="main">` was laid out under the
 * topnav; with only the shell's fixed account pill above it (bottom edge at
 * 64px, 50px on a phone), the page starts 28px below the pill, as the
 * coworld's main page and /play do. Everything else on the page keeps its
 * own look.
 */
/* stylelint-disable-next-line selector-pseudo-class-no-unknown -- CSS Modules :global */
.pillBand :global(main#main) {
  padding-top: calc(92px + var(--shell-nav-extra-height, 0px));
}

@media (max-width: 640px) {
  /* stylelint-disable-next-line selector-pseudo-class-no-unknown -- CSS Modules :global */
  .pillBand :global(main#main) {
    padding-top: calc(78px + var(--shell-nav-extra-height, 0px));
  }
}
